<template>
    <div class="row">
        <div class="col-md-4">
            <div class="d-block mb-3">
                <label class="d-block">
                    <span class="form-label">Assigned To</span>
                    <tech-ac 
                        v-model="form.AssignedTo" 
                        placeholder="Search for a technician..."
                    ></tech-ac>
                </label>
            </div>
        </div>
        <div class="col-md-4">
            <div class="d-block mb-3">
                <label class="d-block">
                    <span class="form-label">Client</span>
                    <client-ac 
                        v-model="form.CustomerNumber" 
                        inputclass="form-control form-control-sm" 
                        placeholder="Search for a client..."
                    ></client-ac>
                </label>
            </div>
        </div>
        <div class="col-md-4">
            <div class="d-block mb-3">
                <label class="d-block">
                    <span class="form-label">Request/Job</span>
                    <job-ac 
                        v-model="form.RequestId" 
                        :client="form.CustomerNumber"
                        
                        placeholder="Search for a request..."
                    ></job-ac>
                </label>
            </div>
        </div>
    </div>

    <div class="row">
        <div :class="form.Id ? 'col-md-4' : 'col-md-6'">
            <label class="d-block mb-3">
                <span>Estimated Time</span>
                <input 
                    class="form-control form-control-sm" 
                    type="text" 
                    v-model="form.EstimatedTime" 
                    placeholder="Hour Estimate" 
                />
            </label>
        </div>
        <div v-if="form.Id" class="col-md-4">
            <label class="d-block mb-3">
                <span>Status</span>
                <select 
                    class="form-select form-select-sm" 
                    v-model="form.Status"
                >
                    <option :value="undefined">Select Status...</option>
                    <option 
                        v-for="status in statusOptions" 
                        :key="status.value" 
                        :value="status.value"
                    >
                        {{ status.label }}
                    </option>
                </select>
            </label>
        </div>
        <div :class="form.Id ? 'col-md-4' : 'col-md-6'">
            <label class="d-block mb-3">
                <span>Start By</span>
                <input type="datetime-local" 
                    class="form-control form-control-sm" 
                    v-model="form.CompleteByDate" 
                    placeholder="Start By"
                >
            </label>
        </div>  
    </div>

    <div class="row">
        <div class="col-12">
            <label class="d-block mb-3">
                <span>Work Assignment</span>
                <textarea class="form-control form-control-sm" placeholder="Work Assignment" v-model="form.WorkAssignment"
                    rows="6"></textarea>
            </label>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import TechAc from "@/components/Techs/TechAc.vue";
import ClientAc from "@/components/Clients/ClientAc.vue";
import JobAc from "@/components/Jobs/JobAc.vue";
import { useTaskStatusStore } from "@/stores/TaskStatusStore";
import { storeToRefs } from "pinia";

const model = defineModel<any>();

const taskStatusStore = useTaskStatusStore();
const { list: taskStatusList } = storeToRefs(taskStatusStore);

// Convert store list to options array for select dropdown
const statusOptions = computed(() => 
    Object.values(taskStatusList.value).map(status => ({
        value: status.Id,
        label: status.Status
    }))
);

// Load task statuses
taskStatusStore.load();

const form = computed({
    get: () => {
        // Ensure Type is set to 'assignment'
        if (model.value && model.value.Type !== 'assignment') {
            model.value.Type = 'assignment';
        }
        return model.value || {};
    },
    set: (value) => {
        if (value) {
            value.Type = 'assignment';
        }
        model.value = value;
    }
});
</script>
